import { render, staticRenderFns } from "./DepartmentsRegistryEditForm.vue?vue&type=template&id=77e9e3cf"
import script from "./DepartmentsRegistryEditForm.vue?vue&type=script&lang=js"
export * from "./DepartmentsRegistryEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports